module.exports = __webpack_public_path__ + "img/g1-3-m.320a4b45.png";